/**
 * QC (Contrôle qualité) capability keys — the EXACT server capability strings
 * (server/src/modules/qc/routes.js, role BIOLOGISTE — the QC-governance authority). useCan / nav
 * gating / ProtectedRoute all key off these. The server re-checks every request; these only
 * hide/disable UI (never the trust boundary, L-4).
 */
export const QC_CAPS = {
  /** Read the open hold worklist + the est-retenu containment probe. */
  retenueRead: "qc.retenue.read",
  /** Open a manual biologiste hold. */
  retenueOpen: "qc.retenue.open",
  /** Lift (lever) an open hold. */
  retenueLift: "qc.retenue.lift",
  /** Record/advance a verdict (the 00c run state machine). */
  controleEvaluate: "qc.controle.evaluate",
  /** Enrol + valider (freeze stats) + sweep a QC lot. */
  lotManage: "qc.lot.manage",
  /** Record a QC observation → auto-evaluate (Westgard). */
  controleRun: "qc.controle.run",
  /** Read the Levey-Jennings chart series. */
  pointRead: "qc.point.read",
} as const;

export type QcCapability = (typeof QC_CAPS)[keyof typeof QC_CAPS];
